<template>
    <div class="overflow-auto">

        <v-select class="ma-2" :items="integrations" v-model="selectedIntegration" :label="$t('integrations.integrations_available')" solo></v-select>

        <transition name="router-anim" >
            
            <ozmap-new-integration class="new-integration" v-if="selectedIntegration === 'OZmap'" @newIntegration='handleNewIntegration' />

        </transition>        

    </div>
</template>

<script>
import OzmapNewIntegration from './OzmapNewIntegration.vue'

export default {

    components: { OzmapNewIntegration },

    name: 'NewIntegrationCard',

    data() {
        return {
            integrations: ['OZmap'],
            selectedIntegration: 'OZmap'
        }
    },

    filters: {

        


    },

    methods: {

        async handleNewIntegration() {

            this.$emit('newIntegration')

        }


    }

}
</script>

<style>

</style>